import React from 'react';
import { PersonalDataCard } from 'entities/users/ui/PersonalDataCard';
import { UserProfileType } from 'entities/user/model/types';
import { useUpdatePersonalDataDefaultValues } from 'entities/users/lib';
import { Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorUpdatePersonalDataUserResponse, PersonalDataUserFormType } from 'entities/users/types';
import { validationSchemaPersonalData } from 'entities/users/model';
import { useChangeUserDataMutation } from 'features/changeUserData/api/changeUserDataApi';
import { CountrySelectId } from 'shared/consts';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useDispatch } from 'react-redux';

type UpdatePersonalDataCardPropsType = {
  user: UserProfileType;
};
export const UpdatePersonalDataCard = ({ user }: UpdatePersonalDataCardPropsType) => {
  const dispatch = useDispatch();
  const defaultValues = useUpdatePersonalDataDefaultValues(user);

  const [changeUserData] = useChangeUserDataMutation();

  const updatePersonalDataForm = useForm<PersonalDataUserFormType>({
    resolver: yupResolver(validationSchemaPersonalData) as Resolver<PersonalDataUserFormType>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<PersonalDataUserFormType> = ({
    first_name,
    last_name,
    middle_name,
    personal_number,
    document_number,
    issued_at,
    expiration_at,
    iin,
    country_id,
    city_id,
  }) => {
    const { setError } = updatePersonalDataForm;
    const createDocument =
      country_id === CountrySelectId.KG || country_id === CountrySelectId.UZ
        ? {
            document_number: document_number.length > 0 ? document_number : null,
            issued_at,
            expiration_at,
            personal_number,
          }
        : null;

    changeUserData({
      id: user.id,
      body: {
        first_name,
        last_name,
        middle_name,
        iin: iin.length > 0 ? iin : null,
        city_id,
        document: createDocument,
      },
    }).then((res) => {
      const { error } = res as ErrorUpdatePersonalDataUserResponse;
      if (error) {
        if (error.status === 422) {
          error.data.errors.map(({ msg, loc }) => {
            loc.map((err) => {
              setError(`${err}`, { message: msg });
            });
          });
        }
      } else {
        dispatch(setDrawerOpen(false));
      }
    });
  };

  return (
    <PersonalDataCard
      form={updatePersonalDataForm}
      onSubmit={onSubmit}
    />
  );
};
